import { MOS_PACKAGE } from '@mxa-argos/constants/mos';

// MOS answers this broadcast with the ids it can see; on Proget devices its IMEI comes only from
// the managed configuration, so a null IMEI means the configuration never reached the app.
export const MOS_IDS_BROADCAST_ACTION = `${MOS_PACKAGE}.RETRIEVE_IDS`;
export const MOS_IDS_BROADCAST_RECEIVER = `${MOS_PACKAGE}/.pigeons.adbinfo.ADBInfoReceiver`;

export const NOTIFICATION_LISTENER = `${MOS_PACKAGE}/${MOS_PACKAGE}.services.notifications.NotificationsListenerService`;

export const OEMCONFIG_RECEIVER =
  'com.motorola.oemconfig.rel/.receivers.ManagedConfigurationsUpdateReceiver';

export const OEMCONFIG_ACTION = 'com.android.vending.APPLICATION_RESTRICTIONS_CHANGED';

export const SETTINGS_PACKAGE = 'com.android.settings';

export const PERFORMANCE_PACKAGE = 'com.ape.performances';

export const PERFORMANCE_ACTIVITY = `${PERFORMANCE_PACKAGE}/.ui.activity.MainPerformanceActivity`;

// Literal label from the Motorola Performance UI; devices are provisioned in Spanish.
export const BACKGROUND_MANAGEMENT_ROW_LABEL = 'Gestión de aplicaciones en segundo plano';

export const DURASPEED_SWITCH_ID = 'com.mediatek.duraspeed:id/status';

export const DURASPEED_EXCLUSION_STEP_NAME = 'DuraSpeed exclusions';

export const DURASPEED_EXCLUDED_APP_LABELS = ['Maximiliana', 'Proget'];

export const UI_DUMP_PATH = '/data/local/tmp/provision_ui.xml';

export const FLASHLIGHT_GESTURE_KEY_BY_MODEL: Record<string, string> = {
  lamul: 'chop_chop_enabled',
  lagos: 'flashlight_on_chop_chop_gesture_enabled',
};

export const LOCATION_PERMISSIONS = [
  'android.permission.ACCESS_COARSE_LOCATION',
  'android.permission.ACCESS_FINE_LOCATION',
  'android.permission.ACCESS_BACKGROUND_LOCATION',
];

export const DEFAULT_PACKAGES = [
  'pl.proget.remote',
  'es.maximiliana.cam',
  'es.maximiliana.gloria',
  'es.maximiliana.carmina',
  'com.whatsapp',
  'org.mozilla.firefox',
  'org.fossify.filemanager',
  MOS_PACKAGE,
];

export const PHASE_A_SETTINGS: readonly [string, string, string][] = [
  ['global', 'wifi_wakeup_enabled', '0'],
  ['system', 'screen_brightness_mode', '0'],
  ['secure', 'doze_enabled', '0'],
  ['secure', 'charging_sounds_enabled', '0'],
  ['secure', 'charging_vibration_enabled', '0'],
  ['secure', 'camera_double_tap_power_gesture_disabled', '1'],
  ['global', 'gestures_display_to_bright', '1'],
  ['global', 'adaptive_battery_management_enabled', '0'],
  ['secure', 'wake_gesture_enabled', '0'],
  ['global', 'power_button_long_press', '1'],
  ['global', 'package_verifier_user_consent', '-1'],
  ['global', 'package_verifier_enable', '0'],
];

// 7 = AC|USB|wireless bitmask. Persists across reboots, so it must be released at the end of the
// run or production devices would keep the screen on while charging.
export const STAY_AWAKE_SETTING: readonly [string, string, string] = [
  'global',
  'stay_on_while_plugged_in',
  '7',
];

export const STAY_AWAKE_RELEASE_SETTING: readonly [string, string, string] = [
  'global',
  'stay_on_while_plugged_in',
  '0',
];

// user_rotation goes first: it is the orientation the display freezes to once auto-rotation is off.
export const ROTATION_LOCK_SETTINGS: readonly [string, string, string][] = [
  ['system', 'user_rotation', '0'],
  ['system', 'accelerometer_rotation', '0'],
];

export const ROTATION_RELEASE_SETTING: readonly [string, string, string] = [
  'system',
  'accelerometer_rotation',
  '1',
];

export const MARK_DELAY_MS = 10_000;

export const MOS_TIMEOUT_MS = 900_000;

export const KIOSK_TIMEOUT_MS = 600_000;

export const KIOSK_REQUEST_INTERVAL_MS = 30_000;

export const MANAGED_CONFIGURATION_TIMEOUT_MS = 90_000;

export const KIOSK_RELEASE_STEP_NAME = 'kiosk released';

export const WIFI_ON_STEP_NAME = 'wifi on';

export const WIFI_OFF_STEP_NAME = 'wifi off';

export const WIFI_VERIFY_TIMEOUT_MS = 10_000;

export const KIOSK_RELEASE_TIMEOUT_MS = 300_000;

export const POLL_INTERVAL_MS = 5_000;

export const POWER_OFF_TIMEOUT_MS = 30_000;

export const READ_TIME_LIMIT_MS = 60_000;

// Authorizing a full bench is a walk down the table, so devices are connected one at a time and the
// queue moves on after this long even if the current prompt is still unanswered.
export const CONNECTION_STAGGER_MS = 20_000;

export const CONNECTION_RETRY_DELAY_MS = 5_000;

// `blob.stream()` yields 64 KiB chunks and Tango turns every chunk into its own ADB packet, so
// coalescing up to the negotiated max payload cuts the USB round trips by an order of magnitude.
// Oversized chunks are safe: the ADB socket splits anything above the negotiated size.
export const INSTALL_CHUNK_SIZE_BYTES = 1024 * 1024;

export const INSTALL_PROGRESS_INTERVAL_MS = 500;

export const INSTALL_STALL_TIMEOUT_MS = 20_000;

export const INSTALL_STALL_CHECK_INTERVAL_MS = 5_000;

// Once the whole APK is uploaded there are no more bytes to watch, so the tail of the install (the
// device unpacking and optimizing the package) gets an absolute deadline instead.
export const INSTALL_COMMIT_TIMEOUT_MS = 180_000;

export const INSTALL_COMMIT_POLL_INTERVAL_MS = 5_000;

export const INSTALL_MAX_ATTEMPTS = 3;

export const INSTALL_RETRY_DELAY_MS = 3_000;

export const INSTALL_VERIFY_TIMEOUT_MS = 10_000;

export const STEP_MAX_ATTEMPTS = 3;

export const STEP_RETRY_DELAY_MS = 2_000;

export const OEMCONFIG_SYNC_TIMEOUT_MS = 60_000;

export const OEMCONFIG_SYNC_MAX_ATTEMPTS = 2;

export const MAX_CONCURRENT_INSTALLS = 5;

export const IMEI_TIMEOUT_MS = 30_000;

export const LOG_MAX_ENTRIES = 20_000;

export const START_SOUND_URL = '/audio/forja-start.mp3';
